import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';

export interface EntityRouteDetails {
  entityId: number;
  entityType: 'org' | 'person';
  underlyingId: number;
}

/**
 * Resolve canonical relation entity id into legacy route ids.
 *
 * Backend: GET /relationentity/entity/{entityId}
 */
@Injectable()
export class EntityRouteService {
  constructor(private requestService: ObservableRequestService) {}

  getEntityRouteDetails(entityId: number | string): Observable<any> {
    return this.requestService.getRequest(`${ConstantsService.RELATION_ENTITY_ROUTE_DETAILS}/${entityId}`);
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/entity-route.service.ts